import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialNextStepConfigExists = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var nextTutorialStepConfig = selectTutorialConfigData(state).nextTutorialStepConfig;
    return nextTutorialStepConfig ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialNextStepConfigExists.ts
// module id = 166
// module chunks = 3